// team
const teamUrl = '/app/team'
const teamShiftUrl = '/app/team-worker'

export const getTeamPage = () => `${teamUrl}`
export const getAllTeam = (version) => `${teamUrl}/cache?version=${version}`
export const getTeamComplex = (id) => `${teamUrl}/${id}`
export const createTeamComplex = () => `${teamUrl}`
export const updateTeamComplex = (id) => `${teamUrl}/${id}`
export const deleteTeamComplex = (id) => `${teamUrl}/${id}`
export const updateTeam = (id) => `${teamUrl}/${id}`

export const createTeamShift = () => `${teamShiftUrl}`
export const updateTeamShift = (id) => `${teamShiftUrl}/${id}`
